import ExceptionHandling from "./exception_handling";
import _ from "underscore";

function stackFromException(exception) {
  return exception.stack || exception.backtrace || exception.stacktrace;
}

export default function onWindowError(message, file, line, characterNumber, exception) {
  ExceptionHandling.lastError = _.last(arguments);

  // All modern versions of the major browsers provide characterNumber above, but try to get it for older versions below
  try {
    // IE < 10 stores character in a global event object
    if (!characterNumber && window.event && window.event['errorCharacter']) {
      characterNumber = window.event['errorCharacter'];
    }
  } catch (e) {
    // do nothing here
  }

  // build exception
  var ex = { name: (exception && exception.name) || "window.onerror",
    message: message.toString(),
    lineNumber: line,
    charNumber: characterNumber,
    fileName: file,
    stack: (exception && stackFromException(exception)) };

  ExceptionHandling.handleException(ex, "window.onerror");

  return ExceptionHandling.suppressBrowserErrorHandling;
}
